
<script>
import { startOfMonth, getMonth, addDays, getYear, format } from 'date-fns';
export default {
  name: 'DateField',
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    },
    allowedDates: {
      type: Function,
      default: () => () => true
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menu: false,
    date: ''
  }),
  computed: {
    dateText () {
      return this.$options.filters.date(this.date);
    },
    classStr () {
      return this.class;
    },
    defaultYearMonthDisplayed () {
      let day = startOfMonth(Date.now());
      let month = getMonth(day);
      while (getMonth(day) <= month + 2) {
        if (this.allowedDates(day)) {
          return getYear(day) + '-' + (getMonth(day) + 1);
        }
        day = addDays(day, 1);
      }

      day = startOfMonth(Date.now());
      while (getMonth(day) >= month - 2) {
        if (this.allowedDates(day)) {
          return getYear(day) + '-' + getMonth(day);
        }
        day = addDays(day, -1);
      }

      return null;
    },
    firstMonthAllowed () {
      let date = new Date();
      let limit = 100;
      while (this.allowedDates(date) === false) {
        date = addDays(date, 1);
        limit -= 1;
        if (limit < 0) {
          return null;
        }
      }
      return format(date, 'yyyy-MM');
    }
  },
  watch: {
    value (val) {
      this.date = val;
    },
    date (val) {
      if (this.closeOnSelect) {
        this.submit();
      }
    },
    menu (val) {
      setTimeout(() => {
        this.$refs.picker.monthClick(this.firstMonthAllowed);
      });
    }
  },
  created () {
    this.date = this.value;
  },
  methods: {
    clearValue () {
      this.date = null;
      this.$emit('input', null);
    },
    cancel () {
      this.date = this.value;
      this.menu = false;
    },
    submit () {
      this.$emit('input', this.date);
      this.menu = false;
    }
  }
};
</script>

<template>
  <div class="v-input v-input-container">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      min-width="290px"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dateText"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          :rules="rules"
          :hide-details="hideDetails"
          :disabled="disabled"
          v-on="on"
        >
          <template v-slot:append>
            <v-icon
              :disabled="disabled"
              @click="clearValue()"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="date"
        no-title
        :allowed-dates="allowedDates"
        first-day-of-week="1"
      >
        <v-spacer />
        <v-btn
          outlined
          @click="cancel()"
        >
          Annuler
        </v-btn>
        <v-btn
          v-if="!closeOnSelect"
          color="primary"
          :disabled="!date"
          @click="submit()"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
.v-input-container{
  max-width: initial;
  ::v-deep .v-input{
    margin: 0 !important;
  }
}
</style>
